import axios, { AxiosResponse } from "axios";
import { apiEndpoint } from "../config";

// Tạo một instance của axios với cấu hình mặc định
const axiosInstance = axios.create({
  baseURL: `${apiEndpoint}`,
  timeout: 0,
  withCredentials: true, // Đảm bảo rằng bạn gửi cookie hoặc token
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
  // Correctly serialize arrays for Spring Boot (ids=1&ids=2 instead of ids[]=1&ids[]=2)
  paramsSerializer: {
    indexes: null // arrayFormat: 'repeat'
  }
});

// Thêm các request interceptor (nếu cần)
axiosInstance.interceptors.request.use(
  (config) => {
    // Thêm token nếu cần, ví dụ:
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Thêm các response interceptor (nếu cần)
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Không log 404 khi component đã xử lý (vd: xóa POS đã bị xóa)
      if (error.response.status !== 404) {
        console.error("Server error:", error.response.data);
      }
    } else if (error.request) {
      console.error("Network error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
